import {ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, Output,} from '@angular/core';

import {GlobalAlertService} from "../../global-alert.service";
import {ButtonCode, GlobalPopup} from '../../global-popup';
import {TranslateService} from "../../../../shared/services/translate/translate.service";
import {Subscription} from "rxjs";
import {GlobalModel} from "../../../../shared/services/state/global.model";
import {AuthorizationService} from "../../../../shared/services/authorization/authorization.service";
import {AbstractBasePopupComponent} from '../abstract-base-popup.component';
import {TooltipService} from "../../../../shared/services/tooltip/tooltip.service";
import {LoggerService} from "../../../../shared/services/logger/logger.service";
import {GlobalPopupControlExceptionEditService} from "./global-popup-control-exception-edit.service";
import {IControlException, IControlExceptionEditorData, IControlExceptionList, IControlFormOption} from "./global-popup-control-exception-edit.interface";
import {take} from "rxjs/operators";
import {IControlProgramList} from "../global-popup-control-program-edit/global-popup-control-program-edit.interface";
import {LumiSelectOption} from "../../../../shared/components/commonUI/select/lumi-select/lumi-select.interface";
import * as moment from "moment";
import {AppSettings} from "../../../../app.settings";
import _default from "chart.js/dist/plugins/plugin.tooltip";
import type = _default.defaults.animations.numbers.type;
import Utils from "../../../../shared/utils/utils";


@Component ({
    selector: 'global-popup-control-exception-edit-component',
    templateUrl: 'global-popup-control-exception-edit.component.html',
    styleUrls: ['global-popup-control-exception-edit.component.scss']
})

export class GlobalPopupControlExceptionEditComponent extends AbstractBasePopupComponent implements DoCheck, OnDestroy {
    private subscriptions: Subscription[] = [];
    @Input() @HostBinding('class.control-v2-embedded-rule') embedded = false;
    @Input() initialData: IControlExceptionEditorData = {};
    @Output() saved = new EventEmitter<void>();
    @Output() dirtyChange = new EventEmitter<boolean>(true);
    private originalException = '';
    private embeddedDirty = false;
    public saving = false;
    @Input() currentActiveFilterQuery:string = '';

    public _mobileMode:boolean = false;
    public _tabletMode:boolean = false;
    public _laptopMode:boolean = false;
    public showList:boolean = false;
    public disableAddExceptionButton:boolean = false;
    public isAddingNewException:boolean = false;
    public hasFormError:boolean = false;
    public activeControlException:IControlException = null;
    public hasChanged:boolean = false;
    public controlExceptionList:IControlExceptionList[] = [];
    public controlProgramsList:IControlProgramList[] = [];
    public dimgroepList:IControlFormOption[] = [];
    public isLoadingControlException:boolean = false;
    public isLoadingControlProgramList:boolean = false;
    public isLoadingDimgroepList:boolean = false;
    public isLoadingControlExceptionList:boolean = true;
    public textualSumup:string = '';
    public availableColorPallet: string[] = AppSettings.CONTROL_PROGRAM_COLOR_PICKER_DEFAULT_OPTIONS;

    public controlProgramsOptions:LumiSelectOption[] = [];
    public dimgroepOptions:LumiSelectOption[] = [];

    public saveSuccess:boolean = false;

    public constructor(protected cd:ChangeDetectorRef, protected elementRef:ElementRef, private controlExceptionService:GlobalPopupControlExceptionEditService, protected globalAlertService:GlobalAlertService, protected ts:TranslateService, private model:GlobalModel, public auth:AuthorizationService, protected tooltipService:TooltipService, protected logger:LoggerService) {
        super(cd, globalAlertService, elementRef, ts, tooltipService, logger);

    }

    ngOnInit(){
        if (this.embedded) {
            this.isLoadingControlExceptionList = false;
            if (this.initialData.controlExceptionId) {
                this.getControlException(this.initialData.controlExceptionId);
            } else if (this.initialData.date) {
                this.addExceptionForDate(this.initialData.date, this.initialData.dimGroupId, this.initialData.dimGroupName);
            } else {
                this.addException();
                if (this.initialData.dimGroupId) {
                    this.activeControlException.selectedDimGroeps = [{id: this.initialData.dimGroupId, name: this.initialData.dimGroupName || ''}];
                }
            }
        } else {
            this.getControlExceptionLists();
        }
        this.getControlProgramLists();
        this.getDimgroepsLists();

        this.subscriptions.push(this.model.mobileMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._mobileMode = value;
            this.checkToDisableNavigation()
        }));
        this.subscriptions.push(this.model.tabletMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._tabletMode = value;
            this.checkToDisableNavigation()
        }));
        this.subscriptions.push(this.model.laptopMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._laptopMode = value;
            this.checkToDisableNavigation()
        }));
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;
        if (!clickedElement.closest('.smart-selection-dropdown')) {
            this.closeAllOptionDropdowns();
        }
    }

    ngDoCheck(): void {
        if (this.embedded && this.activeControlException) {
            const dirty = JSON.stringify(this.activeControlException) !== this.originalException;
            if (dirty !== this.embeddedDirty) {
                this.embeddedDirty = dirty;
                this.dirtyChange.emit(dirty);
            }
        }
    }

    private checkToDisableNavigation():void{
        if(!this._mobileMode && !this._tabletMode && !this._tabletMode){
            this.showList = false;
            this.cd.detectChanges()
        }
    }
    public toggleArticleNavigation(forceClose:boolean = false, preventDefault:boolean = false){
        if((this._mobileMode || this._tabletMode || this._laptopMode) && (!preventDefault)){
            if(!forceClose){
                this.showList = !this.showList;
            } else {
                this.showList = false;
            }
        }
    }

    public copyProgram($event?:MouseEvent):void{
        this.closeAllOptionDropdowns();
        if ($event) {
            this.preventDefault($event);
        }
        this.hasFormError = true;
        this.isAddingNewException = true;
        this.activeControlException.name = '';
        delete this.activeControlException.id;
        this.setSelected(null);
        this.cd.detectChanges();
    }

    public addException(){
        this.isAddingNewException = true;
        this.hasFormError = true;
        this.activeControlException = {
            color:this.availableColorPallet[Math.floor(Math.random()*this.availableColorPallet.length)]
        } as IControlException;

        this.setSelected(null);
        this.cd.detectChanges();
    }

    private addExceptionForDate(isoDate: string, dimGroupId?: number, dimGroupName?: string): void {
        this.addException();
        const [year, month, day] = isoDate.split('-').map(Number);
        const date = new Date(year, month - 1, day).toUTCString();
        this.activeControlException.startDate = date;
        this.activeControlException.endDate = date;
        if (dimGroupId) {
            this.activeControlException.selectedDimGroeps = [{id: dimGroupId, name: dimGroupName ?? ''} as IControlFormOption];
        }
        this.checkForError();
    }

    public selectColor():void {
        this.activeControlException.color = this.activeControlException.color.toUpperCase()
    }

    public changeSelect(field:string, $event: LumiSelectOption[]){
        if (this.embedded && field === 'dimgroep' && !$event.length) {
            this.activeControlException.selectedDimGroeps = [];
            this.checkForError();
            this.populateSumup();
            return;
        }
        if($event.length > 0){
            const selectedId = Number($event[0].id);
            const selectedName = $event[0].name;
            switch(field){
                case 'control-program':
                    this.activeControlException.controlProgram = {
                        id:selectedId,
                        name:selectedName
                    }
                    break;
                case 'dimgroep':
                    this.activeControlException.selectedDimGroeps = [];
                    $event.forEach((_x) => {
                        this.activeControlException.selectedDimGroeps.push({
                            id: typeof _x.id === 'string' ? parseInt(_x.id) : _x.id,
                            name: _x.name,
                        } as IControlFormOption);
                    });
                    break;
            }
        }

        this.checkForError();
        this.populateSumup();
    }

    public getSelect(field:string):LumiSelectOption[]{
        switch(field){
            case 'control-program':
                return this.activeControlException.controlProgram ? [this.controlProgramsOptions.find(_x => {return _x.id === this.activeControlException.controlProgram.id})] : [];
            case 'dimgroep':
                return this.activeControlException.selectedDimGroeps ? this.activeControlException.selectedDimGroeps : [];
            default:
                return null;
        }
    }

    public changeDate(field:string, isoString: any):void{
        const date = new Date(isoString);
        const isEmpty:boolean = date.getFullYear() == 1970;

        switch(field){
            case 'start':
                this.activeControlException.startDate = isEmpty ? null : date.toUTCString()
                break;
            case 'end':
                this.activeControlException.endDate = isEmpty ? null : date.toUTCString()
                break;
        }
        this.checkForError();
        this.populateSumup();
    }

    private showSaveSuccess():void{
        this.saveSuccess = true;
        setTimeout(()=>{
            this.saveSuccess = false;
            this.cd.detectChanges();
        }, 4000)
    }

    public saveException(){
        if (this.embedded && (this.saving || this.hasFormError || !this.auth.allowCreateException())) {
            return;
        }
        if(this.activeControlException.name != ''){
            this.saving = true;
            this.subscriptions.push(this.controlExceptionService.saveControlException(this.activeControlException).subscribe({next: (formPostResult) => {
                this.saving = false;
                if (this.embedded) {
                    this.saved.emit();
                    return;
                }
                let controlException:IControlException = (formPostResult as any);
                if(this.activeControlException.id === null || typeof this.activeControlException.id === 'undefined'){
                    this.controlExceptionList.unshift({
                        id: controlException.id,
                        name: controlException.name,
                        usedBy:this.totalDimgroepsText(controlException.selectedDimGroeps.length),
                        color:controlException.color,
                        controlProgram:controlException.controlProgram,
                        isHidden:false,
                        isSelected:true,
                        showOptionsDropdown:false,
                    })
                    this.setSelected(controlException.id)
                    this.activeControlException = controlException;
                } else {
                    const currentListControlException = this.controlExceptionList.find(_x => {return _x.id == this.activeControlException.id;})
                    currentListControlException.name = controlException.name;
                    currentListControlException.color = controlException.color;
                    currentListControlException.usedBy = this.totalDimgroepsText(controlException.selectedDimGroeps.length);
                    currentListControlException.controlProgram = controlException.controlProgram;
                }
                this.showSaveSuccess();
                this.cd.detectChanges()
            }, error: () => { this.saving = false; }}));
            this.hasChanged = true;
        }
    }

    public totalDimgroepsText(dimgroeps:number|string):string{
        return Number(dimgroeps) === 1 ? '1 '+this.ts.translate('control-exception.dimgroep') : dimgroeps+' '+this.ts.translate('control-exception.dimgroepen');
    }

    public populateSumup():void{
        const a = this.activeControlException;
        const startDate:string = a.startDate !== null ? moment(a.startDate).format('DD-MM-YYYY') : 'X';
        const endDate:string = a.endDate !== null ? moment(a.endDate).format('DD-MM-YYYY') : this.ts.translate('candelarrules.sumup-no-enddate');
        this.textualSumup = this.ts.translate('candelarrules.sumup-one-time', [startDate, endDate]);
        this.cd.detectChanges();
    }

    public deleteActiveControlException():void{
        this.globalAlertService.addPopup(this.ts.translate("control-program.remove-program-title"), this.ts.translate("control-program.remove-program-label"),
            [{label:this.ts.translate("Annuleren"), code:ButtonCode.ANNULEREN, isPrimary:true},
                {label:this.ts.translate("Verwijderen"), code:ButtonCode.DELETE,
                    callback:() => {
                        this.subscriptions.push(this.controlExceptionService.deleteControlException(this.activeControlException.id).pipe(take(1)).subscribe((formGetResult) => {}));
                        this.controlExceptionList.splice(this.controlExceptionList.map(function(e) { return e.id; }).indexOf(this.activeControlException.id),1);
                        this.activeControlException = null;
                        this.cd.detectChanges();
                    },
                    isPrimary:false}
            ], () => {})
    }


    private getControlProgramLists():void{
        this.isLoadingControlProgramList = true;
        this.subscriptions.push(this.controlExceptionService.getControlProgramsList().subscribe((controlProgramList) => {
            this.controlProgramsList = controlProgramList;
            this.controlProgramsList.map(_x => {
                this.controlProgramsOptions.push({id:_x.id,name:_x.name});

            })
            this.isLoadingControlProgramList = false;
            this.cd.detectChanges()
        }));
    }

    private getDimgroepsLists():void{
        this.isLoadingDimgroepList = true;
        this.subscriptions.push(this.controlExceptionService.getDimgroepList().subscribe((dimgroepList) => {
            this.dimgroepList = dimgroepList;
            this.dimgroepList.map(_x => {
                this.dimgroepOptions.push({id:_x.id,name:_x.name});
            })
            this.isLoadingDimgroepList = false;
            this.cd.detectChanges()
        }));
    }


    
    public checkForError(){
        this.hasFormError = typeof this.activeControlException.name === 'undefined'
            || typeof this.activeControlException.controlProgram === 'undefined'
            || typeof this.activeControlException.selectedDimGroeps === 'undefined'
            || typeof this.activeControlException.startDate === 'undefined'
            || typeof this.activeControlException.endDate === 'undefined'
            || this.activeControlException.selectedDimGroeps.length == 0
            || this.activeControlException.startDate == ''
            || this.activeControlException.endDate == ''
            || this.activeControlException.name == ''
            || this.activeControlException.startDate == 'Invalid Date'
            || this.activeControlException.endDate == 'Invalid Date';

        this.cd.detectChanges()
    }

    private getControlExceptionLists():void{
        this.isLoadingControlExceptionList = true;
        this.subscriptions.push(this.controlExceptionService.getControlExceptionList().subscribe((controlExceptionList) => {
            this.controlExceptionList = controlExceptionList;
            this.isLoadingControlExceptionList = false;
            this.cd.detectChanges();

            if(this.globalPopup.data?.date && this.globalPopup.data.controlExceptionId == null) {
                this.addExceptionForDate(this.globalPopup.data.date, this.globalPopup.data.dimGroupId, this.globalPopup.data.dimGroupName);
            } else if(this.controlExceptionList.length > 0){
                if(this.globalPopup.data && this.globalPopup.data.controlExceptionId !== null && typeof this.globalPopup.data.controlExceptionId !== 'undefined') {
                    this.getControlException(this.globalPopup.data.controlExceptionId);
                } else {
                    this.getControlException(this.controlExceptionList[0].id);
                }
            } else {
                this.addException();
            }
        }));
    }

    public getControlException(controlExceptionId:number):void{
        if(this.activeControlException == null || this.activeControlException.id != controlExceptionId){
            this.setSelected(controlExceptionId);
            this.isLoadingControlException = true;
            this.subscriptions.push(this.controlExceptionService.getControlException(controlExceptionId).subscribe((controlException) => {
                this.activeControlException = controlException;
                this.isLoadingControlException = false;
                if (this.embedded) {
                    this.originalException = JSON.stringify(this.activeControlException);
                }
                this.cd.detectChanges();
                this.populateSumup();
                this.checkForError();
                if (this.embedded && this.initialData.copy) {
                    this.copyProgram();
                }
            }));
        }
    }

    public doSearch():void {
        this.controlExceptionList.map(_x => {
            if(this.currentActiveFilterQuery == ''){
                _x.isHidden = false;
            } else {
                _x.isHidden = !(_x.name.toLowerCase().includes(this.currentActiveFilterQuery.toLowerCase()) || _x.controlProgram.name.toLowerCase().includes(this.currentActiveFilterQuery.toLowerCase())) || _x.isSelected;
            }
        })
        this.cd.detectChanges();
    }

    public hasSearchQuery():boolean {
        return !(this.currentActiveFilterQuery == '' || this.currentActiveFilterQuery == null || typeof this.currentActiveFilterQuery == 'undefined');
    }

    public clearSearchQuery():void {
        this.currentActiveFilterQuery = ''
        this.doSearch()
    }

    public canEditExceptionProgram():boolean{
        return !this.embedded || this.auth.allowCreateException();
    }

    public toggleOptionsDropdown(item:IControlExceptionList,$event: MouseEvent):void{
        // Prevent default event
        this.preventDefault($event);
        // Close all other dropdowns
        this.closeAllOtherOptionDropdowns(item);
        this.getControlException(item.id);
        // Toggle dropdown
        item.showOptionsDropdown = !item.showOptionsDropdown;
    }

    public preventDefault($event: MouseEvent): void {
        Utils.preventDefault($event);
    }

    public closeAllOptionDropdowns():void{
        this.controlExceptionList.forEach(_x => {
            _x.showOptionsDropdown = false;
        })
    }
    public closeAllOtherOptionDropdowns(item:IControlExceptionList):void{
        this.controlExceptionList.forEach(_x => {
            if(_x !== item){
                _x.showOptionsDropdown = false;
            }
        })
    }

    private setSelected(controlExceptionId:number):void{
        if(controlExceptionId !== null){
            this.isAddingNewException = false;
        }
        //Set the selected item to false
        this.controlExceptionList.filter(_x => {return _x.isSelected}).map(_x => {_x.isSelected = false});
        //Set current item selected
        this.controlExceptionList.filter(_x => {return _x.id == controlExceptionId}).map(_x => {_x.isSelected = true});
    }

    handlePopupAction(event: MouseEvent, alert: GlobalPopup, button: any): void {
        //Hide alert and perform callback of button
        this.onPopupAction.emit({event:event, alert:alert, button:button, data:{dataChanged:this.hasChanged}});
    }

    public closePopup(event:any):void
    {
        //When the moments have changed, show a are-your-sure-popup
        this.doDefaultCloseHandling(event,this.isAddingNewException);
    }

    ngOnDestroy(){
        this.subscriptions.forEach(subscription => subscription.unsubscribe())
    }

}
